import ageRangeLogic from "./ageRange/logic";
import appLogic from "./app/logic";
import authLogic from "./auth/logic";
import brandsLogic from "./brands/logic";
import channelLogic from "./channel/logic";
import cityLogic from "./city/logic";
import companyInfoLogic from "./companyInfo/logic";
import dashboardLogic from "./dashboard/logic";
import groupLogic from "./group/logic";
import lookupsLogic from "./lookups/logic";
import nationalityLogic from "./nationalities/logic";
import offersLogic from "./offers/logic";
import outletTypeLogic from "./outletType/logic";
import outletsLogic from "./outlets/logic";
import prizeLogic from "./prize/logic";
import productsLogic from "./products/logic";
import promoterLogic from "./promoter/logic";
import refusalReasonLogic from "./refusalReason/logic";
import reportsLogic from "./reports/logic";
import settingLogic from "./setting/logic";
import shiftSessionLogic from "./shiftSessions/logic";
import spinWheelLogic from "./spinningWheel/logic";
import supervisorLogic from "./supervisor/logic";
import surveysLogic from "./survey/logic";
import usersLogic from "./userManagement/logic";
import reportsResponses from "./reportsResponses/logic";
import cee from "./cee/logic";
import pagesLogics from "./pages/logic";
import skusLogics from "./sku/logic";
import productSkusLogics from "./productSku/logic";
import starterKitsLogics from "./starterKit/logic";
//---------------------------

export default [
  ...appLogic,
  ...authLogic,
  ...usersLogic,
  ...settingLogic,
  ...brandsLogic,
  ...productsLogic,
  ...lookupsLogic,
  ...companyInfoLogic,
  ...prizeLogic,
  ...offersLogic,
  ...outletsLogic,
  ...cityLogic,
  ...nationalityLogic,
  ...ageRangeLogic,
  ...promoterLogic,
  ...supervisorLogic,
  ...reportsLogic,
  ...surveysLogic,
  ...dashboardLogic,
  ...refusalReasonLogic,
  ...shiftSessionLogic,
  ...outletTypeLogic,
  ...channelLogic,
  ...groupLogic,
  ...spinWheelLogic,
  ...reportsResponses,
  ...cee,
  ...pagesLogics,
  ...skusLogics,
  ...productSkusLogics,
  ...starterKitsLogics,
];
